export const VISIBLE_OPTION_CLASS = 'visible';

export const DEBOUNCE_TIME_VALUE_CHANGES = 30;

export const NO_ITEMS_FOUND_CLASS = 'no-items-found';

export const MATCHED_OPTION_CLASS = 'matched';
